<template>
  <div class="flex flex-col items-center min-h-screen pt-10">
    <div class="w-full max-w-6xl">
      <div class="flex items-center mb-6">
  <button @click="goBack" class="mr-2 flex items-center justify-center bg-white border border-gray-200 rounded-full w-10 h-10 custom-shadow">
    &#8592; <!-- Unicode символ стрелочки влево -->
  </button>
  <div class="relative flex-grow">
    <svg
      class="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      width="24"
      height="24"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M21 21l-4.35-4.35m1.12-6.32a7 7 0 11-14 0 7 7 0 0114 0z"
      />
    </svg>
    <input
      v-model="directionName"
      type="text"
      placeholder="Поиск"
      class="w-full p-3 pl-12 text-lg border border-gray-300 rounded-full"
    />
  </div>
  <button @click="goHome" class="ml-2 flex items-center justify-center bg-white border border-gray-200 rounded-full w-10 h-10 custom-shadow">
    &#8962; <!-- Unicode символ стрелочки влево -->
  </button>

</div>
      
      <h1 class="text-2xl font-semibold mb-4" v-if="UIStore.сollegesList && UIStore.сollegesList.specialityTitle">
        {{ UIStore.сollegesList.specialityTitle }}
      </h1>
      <div class="w-full lg:w-1/2 mb-4" v-if="!isScreenWide && showMap">
        <YandexMapSmall 
          :center="[59.938784, 30.314997]"
          :markers="markers"
        />
      </div>
      <div class="flex flex-row gap-4" v-if="!UIStore.isPending && UIStore.сollegesList">
        <div class="w-full lg:w-1/2">
          <div class="grid grid-cols-1 gap-4">
            <button @click="goToSite(profession.webSiteUrl)"
              v-for="profession in UIStore.сollegesList.establishments"
              :key="profession.title"
              class="rounded-xl hover:shadow-hover bg-white border border-gray-200 rounded-xl p-4 custom-shadow">
              <div class="flex">
                <img :src="profession.coverUrl" alt="" class="w-24 h-24 rounded-lg object-cover mr-4">
              <div class="text-left flex flex-col justify-between w-full">
                <div>
                  <h2 class="text-lg font-semibold">{{ profession.title }}</h2>
                  <!-- <p class="text-gray-500">{{ profession.programsAmount }} программ для этой профессии </p> -->
                </div>
                <div class="flex justify-between w-full items-end">
                  <div class="flex justify-between w-full items-end">
                  <p class="text-gray-500 font-semibold text-black text-left text-sm">Образование: {{ checkBasis(profession.basis) }}</p>
                  <p class="text-gray-500 font-semibold text-black text-right text-sm">На базе: {{ checkEducation(profession.educationBase) }}-классов</p>
                </div>
                </div>
                <div class="flex justify-between w-full items-end">
                  <p class="text-gray-500 font-semibold text-black text-left text-sm">Кол-во мест: {{ profession.placesAmount }}</p>
                  <p class="text-gray-500 font-semibold text-black text-right text-sm">проходной балл: {{ profession.averageGrade }}</p>
                </div>
              </div>
              </div>
              <div class="flex justify-between w-full items-end mt-3">
                  <div class="flex justify-between w-full items-end">
                  <p class="text-gray-500 font-semibold text-black text-left text-sm">{{ profession.address }}</p>
                  <p class="text-gray-500 font-semibold text-black text-right text-sm">Телефон: {{ profession.phone }}</p>
                </div>
                </div>
            </button>
          </div>
        </div>
        <div class="w-full lg:w-1/2" v-if="isScreenWide && showMap">
          <YandexMap 
            :center="[59.938784, 30.314997]"
            :markers="markers"
          />
        </div>
      </div>
      <div v-else>
        <div class="loader-container">
          <div role="status">
              <svg aria-hidden="true" class="inline w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                  <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
              </svg>
              <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {сollegesListStore} from "@/store/сollegesListStore";
import {onMounted, ref, watch} from "vue";
import {useRoute, useRouter} from "vue-router";
import YandexMap from "@/components/YandexMap.vue";
import YandexMapSmall from "@/components/YandexMapSmall.vue";

const route = useRoute();
const markers = ref([]);
const isScreenWide = ref(window.innerWidth >= 800);
const UIStore = сollegesListStore();
const router = useRouter();

const goBack = () => {
  router.back();
};

const checkEducation = (basis) => {
  if(basis == "NINTH_CLASS"){
    return "9"
  }
  if(basis == "ELEVENTH_CLASS"){
    return "11"
  }
}

const checkBasis = (basis) => {
  if(basis == "FREE"){
    return "Бесплатно"
  }
  if(basis == "PAID"){
    return "Платно"
  }
}

const directionName = ref(''); 

watch(directionName, async (newValue) => {
  // UIStore.getProfessionalisms(route.params.id, newValue)
  markers.value = await UIStore.getCollegesFromSpeciality(route.params.id, newValue);
  // console.log(newValue); // Новый значение directionNamea
});

const goHome = () => {
  router.push({name: 'directions'})
}

const showMap = ref(false);
const goToSite = (link) => {
  window.location.href = link;
};

const updateScreenSize = () => {
  isScreenWide.value = window.innerWidth >= 800;
};

window.addEventListener('resize', updateScreenSize);

onMounted(async () => {
  showMap.value = true;
  markers.value = await UIStore.getCollegesFromSpeciality(route.params.id, directionName.value);
  updateScreenSize();
});


</script>

<style scoped>
.custom-shadow {
  box-shadow: 0 4px 6px rgba(104, 92, 182, 0.2);
  border-radius: 16px; /* Скругляем углы еще больше */
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh; /* Устанавливаем минимальную высоту контейнера */
  margin-top: 4vh; /* Отступ сверху в 4% */
}
.hover\:shadow-hover:hover {
      box-shadow: 0 4px 6px rgba(104, 92, 182, 0.5);
    }
li {
  display: inline-block;
  margin: 0 10px;
}
a { 
  color: #42b983;
}
</style>
